import { Skeleton } from '@mui/material';
import { Stack } from 'shared/mui/Stack/Stack';

import { BoxStyled } from './UsersEditForm.styled';

export const UsersEditSkeleton = () => {
  return (
    <>
      <BoxStyled>
        <Skeleton
          height={24}
          sx={{ marginBottom: '24px', gridColumn: '1 / span 2' }}
          variant="rounded"
          width={100}
        />
        <Skeleton height={40} sx={{ marginBottom: '18px' }} variant="rounded" />
        <Skeleton height={40} sx={{ marginBottom: '18px' }} variant="rounded" />
        <Skeleton height={40} sx={{ marginBottom: '18px' }} variant="rounded" />
        <Skeleton height={40} sx={{ marginBottom: '18px' }} variant="rounded" />
        <Skeleton
          height={40}
          sx={{ marginBottom: '24px', gridColumn: '1 / span 2' }}
          variant="rounded"
        />
        <Skeleton
          height={40}
          sx={{ marginBottom: '32px', gridColumn: '1 / span 2' }}
          variant="rounded"
        />
        <Skeleton height={36} sx={{ gridColumn: '1 / span 2' }} variant="rounded" />
        <Skeleton
          height={24}
          sx={{ marginTop: '32px', marginBottom: '20px', gridColumn: '1 / span 2' }}
          variant="rounded"
          width={180}
        />
      </BoxStyled>
      <Stack direction="row" justifyContent="space-between" mt="12px" width="100%">
        <Skeleton height={36} variant="rounded" width={100} />
        <Stack direction="row" gap={2}>
          <Skeleton height={36} variant="rounded" width={108} />
          <Skeleton height={36} variant="rounded" width={116} />
        </Stack>
      </Stack>
    </>
  );
};
